import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  install(app) {
    library.add(far, fas, fal);
    //   far.faUsersCog
    // far.faUsers,
    // far.faUserCog,
    // far.faHatCowboySide,
    // far.faTrashAlt,
    // far.faPlusCircle,
    // far.faCreditCard,
    // far.faChevronRight,
    // far.faChevronLeft,
    // fas.faCheck,
    // far.faToggleOn,
    // far.faToggleOff,
    // far.faChevronDoubleLeft,
    // far.faChevronDoubleRight,
    // far.faEllipsisH,
    // far.faCalendarAlt,
    // far.faExternalLink,
    // far.faPencil,
    // far.faSave,
    // fas.faSort,
    // fas.faSortUp,
    // fas.faSortDown,
    // far.faPrint,
    // fas.faChartLine,
    // fas.faHorseSaddle,
    // fas.faCogs,
    // fas.faUsers,
    // fas.faWarehouse,
    // fal.faChevronDoubleLeft,
    // fal.faChevronDoubleRight,
    // far.faRandom,
    // fal.faRandom,
    // far.faEnvelope,
    // far.faHome,
    // far.faBell,
    // fas.faBell,
    // fal.faBell,
    // fal.faCog,
    // fal.faCommentAlt,
    // fal.faQuestionCircle,
    // fal.faSquare,
    // fal.faQuestionSquare,
    // fas.faUser,
    // fas.faGlobeAmericas,
    // fal.faAsterisk,
    // fas.faCircle,
    // fas.faGripVertical,
    // far.faBuilding,
    // far.faCube,
    // far.faDigging,
    // far.faPuzzlePiece,
    // far.faStamp,
    // far.faForklift,
    // far.faFileContract,
    // far.faCubes,
    // far.faFileInvoice,
    // far.faBookOpen,
    // fas.faStar,
    //   far.faStar,
    //   far.faEye,
    //   far.faEyeSlash

    app.component("font-awesome-icon", FontAwesomeIcon);
  },
};
